import { initializeErmComponentsExamples } from './examples/ermComponentsExamples.initialize';

export const initializeErmComponents = () => {
    initializeErmComponentsExamples();
};
